export enum EnumBaseNumeracao {
  Transacao = 1,
  GrupoTransacao
}

export const ListaBaseNumeracao = [
  { descricao: "Transação", valor: EnumBaseNumeracao.Transacao },
  { descricao: "GrupoTransacao", valor: EnumBaseNumeracao.GrupoTransacao }
];